import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  CollectionType,
  EchartsTitleMap,
  StatsChartType,
} from '@pages/statistics-page/constants';
import { StatsChartConfiguration } from '@pages/statistics-page/interfaces';
import { StatisticsDataService } from '@pages/statistics-page/services/statistics-data.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-trips',
  templateUrl: './trips.component.html',
  styleUrls: ['../../../styles/chart-wrapper.scss'],
  providers: [
    StatisticsDataService,
    { provide: 'chartGroupType', useValue: CollectionType.Trips },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TripsComponent implements OnInit {
  private dataService = inject(StatisticsDataService);

  tripsChartData$: Subject<Map<StatsChartType, StatsChartConfiguration>>;

  chartType: typeof StatsChartType = StatsChartType;
  chartTitle: typeof EchartsTitleMap = EchartsTitleMap;

  ngOnInit(): void {
    this.tripsChartData$ = this.dataService.chartData$;
  }
}
